/* Violet Eyes, phones: filter panel (snippets/ve-phone-filter.liquid).
   Opens from the header's sliders button ([data-ve-pf-open]); closes with ✕, a tap on the dimmed page,
   Esc, or a swipe down on the panel. "View results" submits the form (page reloads with the picks). */
if (!customElements.get('ve-phone-filter')) {
  // One listener for the header's Filter button, whichever copy of the panel is on the page now (the panel is replaced
  // when the categories change, see assets/ve-collection.js).
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ve-pf-open]');
    const panel = document.querySelector('ve-phone-filter');
    if (!opener || !panel) return;
    event.preventDefault();
    panel.opener = opener;
    panel.open();
  });
  // The hamburger button while the Filter panel is open (BNJMN, 27 Oct): the panel's dimmed page covers the header, so a tap
  // there would only close the panel. A tap where the hamburger button is closes the panel at once and opens the menu on top.
  document.addEventListener(
    'click',
    (event) => {
      if (!document.documentElement.classList.contains('ve-pf-open')) return;
      const panel = document.querySelector('ve-phone-filter');
      const button = document.querySelector('[data-ve-menu-open]');
      if (!panel || panel.hidden || !button) return;
      const box = button.getBoundingClientRect();
      if (box.width === 0 || event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      panel.close({ now: true });
      button.click();
    },
    true
  );
  // 3 Nov (BNJMN): a filter group opens and closes smoothly (height + a soft fade of its list) while the + turns into a –
  // (CSS: the + is two strokes, the upright one rotates flat). One listener for whichever copy of the panel is on the page.
  const ease = 'cubic-bezier(0.33, 0, 0.15, 1)';
  const slideGroup = (group, summary) => {
    if (group.veAnim) group.veAnim.cancel();
    const kids = [...group.children].filter((child) => child !== summary);
    const start = group.offsetHeight;
    const closing = group.open && !group.classList.contains('is-closing');
    let end;
    if (closing) {
      group.classList.add('is-closing');
      end = summary.offsetHeight;
      kids.forEach((child) => child.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 250, easing: 'ease', fill: 'forwards' }));
    } else {
      group.classList.remove('is-closing');
      group.open = true;
      end = group.offsetHeight;
      kids.forEach((child) => {
        child.getAnimations().forEach((animation) => animation.cancel());
        child.animate([{ opacity: 0, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'none' }], { duration: 380, delay: 80, easing: ease, fill: 'backwards' });
      });
    }
    group.style.overflow = 'hidden';
    const animation = group.animate([{ height: `${start}px` }, { height: `${end}px` }], { duration: 450, easing: ease });
    group.veAnim = animation;
    let done = false;
    const finish = () => {
      if (done || group.veAnim !== animation) return;
      done = true;
      group.veAnim = null;
      group.style.overflow = '';
      if (closing) {
        group.open = false;
        group.classList.remove('is-closing');
        kids.forEach((child) => child.getAnimations().forEach((item) => item.cancel()));
      }
    };
    animation.onfinish = finish;
    // paused animation frames (hidden tab): finish anyway
    setTimeout(finish, 700);
  };
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.ve-pf__summary');
    if (!summary || !summary.parentElement.matches('details.ve-pf__group')) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || typeof summary.animate !== 'function') return;
    event.preventDefault();
    slideGroup(summary.parentElement, summary);
  });
  customElements.define(
    've-phone-filter',
    class VePhoneFilter extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.sheet = this.querySelector('.ve-pf__sheet');
        // a mark on the header's Filter icon while a filter is picked in the panel (sort is not a filter; the category picks are not in the panel)
        const filterInputs = () => [...this.querySelectorAll('.ve-pf__body input')].filter((input) => input.name !== 'sort_by');
        const mark = () => {
          // a panel that was replaced by a fresh one (after a category change) must not touch the header any more
          if (!this.isConnected) return;
          const on = filterInputs().some((input) => (input.type === 'checkbox' || input.type === 'radio' ? input.checked : input.value !== ''));
          document.querySelectorAll('[data-ve-pf-open]').forEach((button) => button.toggleAttribute('data-has-filters', on));
          this.querySelectorAll('[data-ve-pf-clear]').forEach((button) => (button.disabled = !on));
        };
        mark();
        this.addEventListener('change', mark);
        this.addEventListener('input', mark);
        // the browser may restore ticked boxes a moment after the page is ready
        window.addEventListener('pageshow', mark);
        // "Clear all": unticks every filter and empties the price fields; the panel stays open, the sort stays, "View results" applies it
        this.querySelectorAll('[data-ve-pf-clear]').forEach((button) =>
          button.addEventListener('click', () => {
            filterInputs().forEach((input) => {
              if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
              else input.value = '';
            });
            mark();
          })
        );
        // 3 Nov (BNJMN): price brackets. A tap fills Shopify's min / max fields (hidden); the picked bracket again empties them.
        const priceMin = this.querySelector('.ve-pf__price input[name$=".gte"]');
        const priceMax = this.querySelector('.ve-pf__price input[name$=".lte"]');
        const brackets = [...this.querySelectorAll('.ve-pf__bracket')];
        const syncBrackets = () => {
          if (!priceMin || !priceMax) return;
          brackets.forEach((button) => {
            const on = (priceMin.value !== '' || priceMax.value !== '') && priceMin.value === button.dataset.min && priceMax.value === button.dataset.max;
            button.setAttribute('aria-pressed', String(on));
          });
        };
        brackets.forEach((button) =>
          button.addEventListener('click', () => {
            if (!priceMin || !priceMax) return;
            const on = button.getAttribute('aria-pressed') === 'true';
            priceMin.value = on ? '' : button.dataset.min;
            priceMax.value = on ? '' : button.dataset.max;
            syncBrackets();
            priceMin.dispatchEvent(new Event('input', { bubbles: true }));
          })
        );
        this.querySelectorAll('[data-ve-pf-clear]').forEach((button) => button.addEventListener('click', syncBrackets));
        syncBrackets();
        // search results: Shopify doesn't know the "New" sort there (assets/ve-compact-search.js orders it),
        // so take the picked sort from the address, and keep it in "Clear all"
        const sort = new URLSearchParams(location.search).get('sort_by');
        const radios = [...this.querySelectorAll('input[name="sort_by"]')];
        if (sort && !radios.some((input) => input.checked)) {
          const picked = radios.find((input) => input.value === sort);
          if (picked) {
            picked.checked = true;
            const clear = this.querySelector('.ve-pf__clear');
            if (clear) {
              const url = new URL(clear.href, location.origin);
              url.searchParams.set('sort_by', sort);
              clear.href = url.pathname + url.search;
            }
          }
        }
        this.querySelectorAll('[data-ve-pf-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        // leave empty price fields out of the address
        this.querySelector('form')?.addEventListener('submit', (event) => {
          // the picked categories (menu: product types or tags) live in the address, not in this panel: carry them along
          const form = event.currentTarget;
          form.querySelectorAll('input[data-ve-carried]').forEach((input) => input.remove());
          const now = new URLSearchParams(window.location.search);
          ['filter.p.product_type', 'filter.p.tag'].forEach((key) =>
            now.getAll(key).forEach((value) => {
              const carried = document.createElement('input');
              carried.type = 'hidden';
              carried.name = key;
              carried.value = value;
              carried.dataset.veCarried = '';
              form.appendChild(carried);
            })
          );
          event.currentTarget.querySelectorAll('input[type="number"]').forEach((input) => {
            if (input.value === '') input.disabled = true;
          });
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
        });
        // swipe down to close (from the handle / heading, or anywhere when the list is at its top)
        const body = this.querySelector('.ve-pf__body');
        let startY = null;
        let dy = 0;
        this.sheet.addEventListener(
          'touchstart',
          (event) => {
            const inBody = body.contains(event.target);
            if (inBody && body.scrollTop > 0) return;
            startY = event.touches[0].clientY;
            dy = 0;
          },
          { passive: true }
        );
        this.sheet.addEventListener(
          'touchmove',
          (event) => {
            if (startY === null) return;
            dy = Math.max(0, event.touches[0].clientY - startY);
            if (dy > 0) {
              this.sheet.style.transition = 'none';
              this.sheet.style.transform = `translateY(${dy}px)`;
              // the blur and the dim fade out in step with the pull
              const progress = Math.min(dy / Math.max(this.sheet.offsetHeight, 1), 1);
              const root = document.documentElement;
              root.classList.add('ve-drag-blur');
              root.style.setProperty('--ve-blur', `${(1.3 * (1 - Math.min(progress * 2.5, 1))).toFixed(2)}px`);
              const veil = this.querySelector('.ve-pf__veil');
              if (veil) {
                veil.style.transition = 'none';
                veil.style.opacity = String(1 - progress * 0.8);
              }
            }
          },
          { passive: true }
        );
        this.sheet.addEventListener('touchend', () => {
          if (startY === null) return;
          this.sheet.style.transition = '';
          this.sheet.style.transform = '';
          document.documentElement.classList.remove('ve-drag-blur');
          document.documentElement.style.removeProperty('--ve-blur');
          const veil = this.querySelector('.ve-pf__veil');
          if (veil) {
            veil.style.transition = '';
            veil.style.removeProperty('opacity');
          }
          if (dy > 90) this.close();
          startY = null;
        });
      }

      // The panel is never lower than the top of the first photos (3px above them), so no strip of photos peeks out above it
      // (as with the Categories sheet). Normally 75% of the screen; taller only when the photos start higher than that.
      position() {
        const first = document.querySelector('#ProductGridContainer .grid__item, #product-grid li, #product-grid .grid__item');
        const header = document.querySelector('ve-header');
        const floor = Math.max(0, header ? header.getBoundingClientRect().bottom : 0);
        const normal = window.innerHeight * 0.25;
        if (!first) return this.sheet.style.removeProperty('--ve-pf-height');
        const wanted = Math.floor(first.getBoundingClientRect().top - 3);
        if (wanted >= normal) return this.sheet.style.removeProperty('--ve-pf-height');
        this.sheet.style.setProperty('--ve-pf-height', `${Math.round(window.innerHeight - Math.max(wanted, floor))}px`);
      }

      open() {
        this.hidden = false;
        this.position();
        document.documentElement.classList.add('ve-pf-open');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.classList.add('is-open'));
        });
        // fallback when animation frames are paused
        setTimeout(() => this.classList.add('is-open'), 50);
        this.opener?.setAttribute('aria-expanded', 'true');
        setTimeout(() => this.sheet.focus({ preventScroll: true }), 60);
      }

      // close({ now: true }) hides the panel at once, without sliding and without moving focus (used when the Categories line is tapped)
      close(options) {
        if (this.hidden) return;
        this.classList.remove('is-open');
        document.documentElement.classList.remove('ve-pf-open');
        this.opener?.setAttribute('aria-expanded', 'false');
        if (options && options.now) {
          this.hidden = true;
          this.sheet.style.transition = '';
          this.sheet.style.transform = '';
          return;
        }
        const done = () => {
          if (!this.classList.contains('is-open')) this.hidden = true;
        };
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) done();
        else setTimeout(done, 400);
        this.opener?.focus({ preventScroll: true });
      }
    }
  );
}
